import React, { useState, useRef, useEffect } from 'react'
import { WhitelabelConfig, useEventListener } from 'hooks'
import { ReactComponent as KavkomPreloader } from 'assets/svg/logo-preloader.svg'
import './Preloader.scss'

let PreloaderLogo = KavkomPreloader

const isWhitelabel = WhitelabelConfig?.logo?.hasOwnProperty('full')

if (isWhitelabel) {
    const { url, width, height } = WhitelabelConfig.logo.full
    PreloaderLogo = () => <img src={url} width={width} height={height} alt="Company logo" />
}

export const Preloader = () => {
    const [domLoading, setDomLoading] = useState(true)

    const appPreloader = useRef()
    const appLogo = useRef()

    const onReadyStateChanged = () => {
        if(document.readyState !== 'complete' || !appPreloader.current) return;
        appPreloader.current.classList.add('is-hide')

        setTimeout(() => {
            if(appLogo.current) appLogo.current.style.display = 'none'
        }, 300)

        setTimeout(() => {
            setDomLoading(false)
        }, 500)
    }

    useEventListener('readystatechange', onReadyStateChanged, document)
    useEffect(onReadyStateChanged, [document.readyState])

    return (
        domLoading && (
            <div className="app-preloader" ref={appPreloader}>
                <div className="app-preloader__container">
                    <div className="app-preloader__logo" ref={appLogo}>
                        <div className="app-preloader__shake">
                            {!isWhitelabel && <div className="app-preloader__circle"></div>}
                            <PreloaderLogo className="app-preloader__image" />
                        </div>
                    </div>
                </div>
            </div>
        )
    )
}
